class ZoomControl {
  constructor(api, map) {
    this.control = new api.ZoomControl(map.getWrapee(), { position: "topRight" });
  }
}

export default ZoomControl;
